var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.file
    ? _c(
        "a",
        {
          staticClass: "download",
          class: _vm.type,
          attrs: { href: _vm.fileUrl, target: "_blank", download: "" },
        },
        [
          _c("Icon", { attrs: { icon: "download" } }),
          _vm._v(" "),
          _c("div", { staticClass: "download__text" }, [
            _vm._v("Download datasheet (" + _vm._s(_vm.fileFormat) + ")"),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }